import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "../firebase";

const authContext = createContext();

export const useAuth = () => {
  const context = useContext(authContext);
  if (!context) throw new Error("There is no Auth provider");
  return context;
};

const ADMIN_ROLES = [
  "coordinador de soporte técnico",
  "administrador",
];

async function fetchUserRole(email) {
  try {
    const res = await fetch("https://desarrollotecnologicoar.com/api5/tecnicos");
    const tecnicos = await res.json();
    const tecnico = tecnicos.find(
      (t) => t.correo_tecnico?.toLowerCase() === email.toLowerCase()
    );
    if (tecnico && ADMIN_ROLES.includes(tecnico.puesto?.toLowerCase())) {
      return tecnico.puesto.toLowerCase();
    }
    return "generico";
  } catch (err) {
    console.error("Error fetching role:", err);
    return "generico";
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState("generico");
  const [loading, setLoading] = useState(true);

  const isAdmin = ADMIN_ROLES.includes(role);

  const signup = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const loginWithGoogle = () => {
    const googleProvider = new GoogleAuthProvider();
    return signInWithPopup(auth, googleProvider);
  };

  const logout = () => signOut(auth);

  const resetPassword = async (email) => sendPasswordResetEmail(auth, email);

  useEffect(() => {
    const unsubuscribe = onAuthStateChanged(auth, async (currentUser) => {
      console.log({ currentUser });
      setUser(currentUser);
      if (currentUser?.email) {
        const userRole = await fetchUserRole(currentUser.email);
        setRole(userRole);
      } else {
        setRole("generico");
      }
      setLoading(false);
    });
    return () => unsubuscribe();
  }, []);

  return (
    <authContext.Provider
      value={{
        signup,
        login,
        user,
        role,
        isAdmin,
        logout,
        loading,
        loginWithGoogle,
        resetPassword,
      }}
    >
      {children}
    </authContext.Provider>
  );
}
